import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { AnalyticsContext, ProviderProps } from './analytics.context';

import { Analytics } from '@cowbell/data/analytics';
import {
  selectAnalyticsEnabled,
  selectDebugModeEnabled,
} from '../../reducers/UxReducers';

export function AnalyticsProvider(props: ProviderProps) {
  const { children, instance } = props;
  const debugModeEnabled = useSelector(selectDebugModeEnabled);
  const analyticsEnabled = useSelector(selectAnalyticsEnabled);
  const nextInstance = useMemo(() => {
    if (instance) {
      return instance;
    }

    return new Analytics({
      debug: debugModeEnabled,
      enabled: analyticsEnabled,
    });
  }, [debugModeEnabled, instance, analyticsEnabled]);

  return (
    <AnalyticsContext.Provider value={nextInstance}>
      {children}
    </AnalyticsContext.Provider>
  );
}
